<template>
  <div class="hpHeaderWrap">
    <header>
      <div class="hpHeader_topBar">
        <div class="hpHeader_topBarIn">
          <div class="left-menu">
            <!-- 여기에 로고나 추가적인 내용을 넣을 수 있습니다.
            로고나 글자 등 내용이 들어가면 자동으로 왼쪽으로 정렬됩니다. -->
          </div>
          <div class="hpHeader_topBar_right">
            <router-link to="/">HOME</router-link>
            <router-link to="/Login" :class="sessionData.customer === '' ? '' : 'display_none'">로그인</router-link>
            <router-link to="/Join" :class="sessionData.customer === '' ? '' : 'display_none'">회원가입</router-link>
            <a :class="sessionData.customer !== '' ? '' : 'display_none'" v-on:click="logout">로그아웃</a>
            <router-link to="/Community?communityID=3">온라인문의</router-link>
            <a href="/TravelProduct?departureConfirmed=1" style="color:#098b80;">출발확정여행</a>
          </div>
        </div>
      </div>

      <div class="hpHeader_mainBox">
        <div class="hpHeader_mainLogoIcon">
          <div class="hpHeader_mainLogo">
            <router-link to="/" >
              <img src="../../../assets/images/happy_train_logo.png" alt="로고"/>
            </router-link>
          </div>

          <div class="hpHeader_mainIcon">
            <a v-on:click="checkSession(1)">
                <img src="../../../assets/images/icon/icon_mypage.png" alt="마이메뉴">
                <span>마이메뉴</span>
            </a>
            <a v-on:click="checkSession(2)">
              <img src="../../../assets/images/icon/icon_reserve.png" alt="예약현황">
              <span>예약현황</span>
            </a>
            <a v-on:click="checkSession(3)">
              <img src="../../../assets/images/icon/icon_interest.png" alt="관심여행">
              <span>관심여행</span>
            </a>
          </div>
        </div>

        <div class="hpHeader_mainSearch"> <!-- search-bar -->
          <div class="hpHeader_mainSearch_searchBox">
            <input type="text" v-model="statusData.travelSearchData" placeholder="검색어를 입력해주세요." @keydown.enter="search" maxlength="20"/>
            <button class="search-btn" @click="search">
              <img src="../../../assets/images/icon/icon_search.png" alt="검색"/>
            </button>
          </div>
          <div class="hpHeader_mainSearch_keywords">
            <p class="hpHeader_mainSearch_keywords_hot"><!-- hot-keywords -->
              HOT <span>검색어</span>
            </p>
            <swiper :options="statusData.searchSwiperOptions" class="hpHeader_mainSearch_keywords_word">
              <swiper-slide
                  v-for="item in statusData.hotKeywordData"
                  :key="item.hot_keyword_ID"
                >
                <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(item.hot_keyword_name)}`">
                  #{{ item.hot_keyword_name }}
                </a>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>

      <nav :class="{'hpHeader_fixed': statusData.isSticky}" class="hpHeader_nav"><!-- main-nav -->
        <div class="hpHeader_nav_menuBar">
          <ul>
            <li class="hpHeader_menuIcon">
              <div>
                <button class="hpHeader_menuOpen" @click="toggleMenu" v-show="!menuOpen"/> <!-- 메뉴 열기 버튼 -->
                <button class="hpHeader_menuClose" @click="toggleMenu" v-show="menuOpen"/> <!-- 메뉴 닫기 버튼 -->
                </div>
            </li>
            <li><a href="/TravelProduct?travelTypeDivision=1">국악와인열차</a></li>
            <li><a href="/TravelProduct?travelTypeDivision=2">팔도장터열차</a></li>
            <li><a href="/TravelProduct?travelTypeDivision=3">일반기차여행</a></li>
            <li><a href="/TravelProduct?travelTypeDivision=4">버스/자유여행</a></li>
            <li><a href="/TravelProduct?travelTypeDivision=5">섬/제주/해외여행</a></li>
            <li><router-link to="/Performance">공연</router-link></li>
            <li><router-link to="/Community">커뮤니티</router-link></li>
          </ul>
        </div>
        <div class="hpHeader_menuAllBody" v-show="menuOpen">
          <div class="hpHeader_menuAllWrap"> <!-- menu-container -->
            <!-- menu-category -->
            <div class="hpHeader_menuAllBox" v-for="category in statusData.travelCategories" :key="category.travel_type_division">
              <h3>
                <a :href="'/TravelProduct?travelTypeDivision='+category.travel_type_division">{{ category.travel_type_division_name }}</a>
              </h3>
              <div class="hpHeader_menuAllBox_cate">
                <a v-for="(travel_type, index) in category.travel_types" :key="index"
                :href="'/TravelProduct?travelTypeDivision='+category.travel_type_division+'&travelTypeID='+travel_type.travel_type_ID">
                  {{ travel_type.travel_type_name }}
                </a>
              </div>
            </div>
            <div class="hpHeader_menuAllBox">
              <h3>
                <a href="/Performance">공연</a>
              </h3>
              <div class="hpHeader_menuAllBox_cate">
                <a href="/Performance">공연</a>
              </div>
            </div>
            <div class="hpHeader_menuAllBox">
              <h3>
                <a href="/Community">커뮤니티</a>
              </h3>
              <div class="hpHeader_menuAllBox_cate">
                <a href="/Community?communityID=1">공지사항</a>
                <a href="/Community?communityID=2">여행후기</a>
                <a href="/Community?communityID=3">온라인문의</a>
                <a href="/Community?communityID=4">자주 묻는 질문</a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import {
  get_session_customer,
  get_homepage_menu,
  delete_session_customer,
  get_hot_keyword_top10,
  count_hot_keyword
} from '../../ETC/Axios.vue'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import { ref } from 'vue'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  name: 'Header',
  setup () {
    const menuOpen = ref(false)
    return {
      sessionData: ref({
        customer: ''
      }),
      statusData: ref({
        hotKeywordData: [],
        searchSwiperOptions: {
          direction: 'vertical',
          autoplay: {
            delay: 2000,
            disableOnInteraction: false
          },
          loop: true
        },
        isSticky: false,
        travelSearchData: '',
        travelCategories: []

      }),
      menuOpen
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    toggleMenu () {
      this.menuOpen = !this.menuOpen
    },
    logout: function () {
      delete_session_customer().then(result => {
        window.location.href = '/'
      })
    },
    checkSession (myID) {
      if (this.sessionData.customer === '') {
        window.location.href = '/Login'
      } else {
        window.location.href = `/My?myID=${myID}`
      }
    },
    handleScroll () {
      this.statusData.isSticky = window.scrollY > 100
    },
    search () {
      if (!this.statusData.travelSearchData.trim()) {
        alert('검색어를 입력해주세요.')
        return
      }
      count_hot_keyword(this.statusData.travelSearchData).then(result => {
        window.location.href = `/TravelProduct?travelSearchData=${encodeURIComponent(this.statusData.travelSearchData)}`
      })
    },
    groupTravelData (travelData) {
      const groupedData = []
      travelData.forEach((item) => {
        const division = groupedData.find(group => group.travel_type_division === item.travel_type_division)
        if (division) {
          division.travel_types.push({
            travel_type_name: item.travel_type_name,
            travel_type_ID: item.travel_type_ID
          })
        } else {
          groupedData.push({
            travel_type_division: item.travel_type_division,
            travel_type_division_name: item.travel_type_division_name,
            travel_types: [{
              travel_type_name: item.travel_type_name,
              travel_type_ID: item.travel_type_ID
            }]
          })
        }
      })
      return groupedData
    }
  },
  mounted () {
    get_hot_keyword_top10().then(result => {
      this.statusData.hotKeywordData = result
    })
    get_session_customer().then(result => {
      this.sessionData.customer = result
    })
    get_homepage_menu().then(result => {
      this.statusData.travelCategories = this.groupTravelData(result)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Section/Header.vue